import { useContext } from 'react';

import EventContext, { IEventContext } from './EventContext';

export default function useEvent() {
  return useContext<IEventContext>(EventContext);
}
